var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let JvCameraTile = class JvCameraTile extends LitElement {
    static { this.styles = css `
    :host {
      display: block;
    }
    .tile {
      background: var(--jv-surface);
      border: 1px solid var(--jv-border);
      border-radius: 16px;
      overflow: hidden;
      transition: transform .18s ease, box-shadow .18s ease;
      cursor: pointer;
    }
    .tile:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(58,53,48,.08), 0 24px 48px -20px rgba(58,53,48,.22);
    }
    .tile.offline {
      cursor: default;
      opacity: .65;
    }
    .tile.offline:hover {
      transform: none;
      box-shadow: 0 1px 2px rgba(58,53,48,.06), 0 8px 24px -12px rgba(58,53,48,.14);
    }
    .preview {
      height: 130px;
      position: relative;
    }
    .preview .placeholder {
      height: 100%;
    }
    .preview .badge-row {
      position: absolute;
      top: 10px;
      left: 10px;
      right: 10px;
      display: flex;
      align-items: center;
      gap: 6px;
    }
    .info {
      padding: 14px 16px;
    }
    .status-live { background: #EF8B6B; }
    .status-online { background: #4C9A6A; }
    .status-offline { background: #7A7167; }
  `; }
    get _isClickable() {
        return this.camera.status !== 'offline';
    }
    _handleClick() {
        if (!this._isClickable)
            return;
        this.dispatchEvent(new CustomEvent('view-camera', {
            detail: { cameraId: this.camera.id },
            bubbles: true,
            composed: true,
        }));
    }
    _statusBadge() {
        const status = this.camera.status;
        if (status === 'live') {
            return html `<span class="jv-badge bg-jv-accent-050 text-jv-accent"><span class="jv-live-dot"></span> Live</span>`;
        }
        if (status === 'online') {
            return html `<span class="jv-badge bg-jv-success-050 text-jv-success"><span class="inline-block w-2 h-2 rounded-full bg-jv-success mr-0.5"></span> Online</span>`;
        }
        return html `<span class="jv-badge bg-jv-surface-2 text-jv-ink-2">Offline</span>`;
    }
    render() {
        const { camera } = this;
        const isOffline = camera.status === 'offline';
        return html `
      <div class="tile ${isOffline ? 'offline' : ''}" @click=${this._handleClick}>
        <div class="preview">
          <div class="jv-video-ph placeholder"></div>
          <div class="badge-row">
            ${this._statusBadge()}
          </div>
        </div>
        <div class="info">
          <p class="font-bold text-sm text-jv-ink truncate">${camera.name}</p>
          <p class="text-xs text-jv-ink-2 mt-0.5">${camera.room}</p>
        </div>
      </div>
    `;
    }
};
__decorate([
    property({ type: Object })
], JvCameraTile.prototype, "camera", void 0);
JvCameraTile = __decorate([
    customElement('jv-camera-tile')
], JvCameraTile);
export { JvCameraTile };
